module.exports = __webpack_public_path__ + "static/img/zone3.de3b60b.svg";


//////////////////
// WEBPACK FOOTER
// ./img/advisory-tool/svg/zone3.svg
// module id = 1018
// module chunks = 1